<template>
  <b-card
    class="collapsable-card"
    no-body
  >
    <b-card-body>
      <div
        class="collapsable-card-header"
        :class="headerClass"
        tabindex="0"
        role="button"
        @keyup.enter="toggle"
        @click="toggle"
      >
        <div class="header-content">
          <div
            v-if="subtitle"
            class="title-container"
          >
            <b-row v-if="icon">
              <b-col
                cols="2"
                class="p-3"
              >
                <i
                  :class="icon"
                  aria-hidden="true"
                />
              </b-col>
              <b-col
                v-if="subtitle"
                cols="10"
                class="pt-2"
              >
                <small>{{ subtitle }}</small>
                <h4
                  class="collapsable-card-title"
                  :class="{errorColor: hasError}"
                >
                  {{ title }}
                </h4>
              </b-col>
            </b-row>
          </div>
          <div
            v-if="!subtitle"
            class="title-container d-flex align-items-center"
          >
            <div class="icon-collapse">
              <i
                :class="fa"
                aria-hidden="true"
              />
            </div><h4
              class="collapsable-card-title"
              style="margin:0"
            >
              {{ title }}
            </h4>
            <slot name="bubbles" />
          </div>
          <slot name="additional-info" />
          <div
            v-if="!showCollapse"
            class="flex-grow-1"
          >
            <slot name="collapsed-content" />
          </div>
        </div>
        <div class="text-right flex-btn d-flex align-items-center">
          <div
            class="d-flex align-items-center justify-content-end"
            @click.stop=""
          >
            <slot name="buttons" />
          </div>
          <fa-icon
            class="arrow-icon"
            :icon="chevron"
          />
          <fa-icon
            class="toggle-more"
            :icon="more"
          />
        </div>
      </div>
      <b-collapse
        :id="collapseId"
        v-model="showCollapse"
        :visible="visible"
        @shown="$emit('onPatientCollapsableShown')"
      >
        <div class="collapsable-card-content">
          <slot />
        </div>
      </b-collapse>
    </b-card-body>
  </b-card>
</template>

<script>

export default {
    name: 'VtCollapsableCard',
    props: {
        title: { type: String, required: true },
        collapseId: { type: String, required: true },
        visible: { type: Boolean, default: false },
        icon: { type: String },
        subtitle: { type: String },
        error: { type: Boolean },
        fa: { type: String }
    },
    data() {
        return {
            showCollapse: this.visible,
            hasError: false
        }
    },
    computed: {
        chevron() {
            return this.showCollapse ? ['fal', 'chevron-up'] : ['fal', 'chevron-down']
        },
        more() {
            return this.showCollapse ? ['fal', 'minus-square'] : ['fal', 'plus-square']
        },
        headerClass() {
            return { 'showing-collapse': this.showCollapse }
        },
        errorProp() {
            return this.error
        }
    },
    watch: {
        errorProp(newValue) {
            this.hasError = newValue
        }
    },
    methods: {
        toggle() {
            this.showCollapse = !this.showCollapse
        }
    }
}

</script>

<style>

.errorColor{
  color: red !important;
}

</style>

<style scoped lang="scss">

.toggle-more{
  display: none;
}

.icon-collapse{
  width: 40px;
}

.icon-collapse i{
  font-size: 1.4rem;
}

.card-body {
  padding: 0;
}

.collapsable-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px 8px 24px;
  &.showing-collapse {
    border-bottom: 1px solid #d8d8d8;
  }
}

.collapsable-card-title {
  font-weight: normal;
}

.header-content {
  display: flex;
  flex: 1 1 auto;
}

.title-container {
  flex: 0 0 180px;
  margin-right: 1rem;
}

.collapsable-card-content {
  padding: 1rem;
}

</style>
